
import { ACCOUNT_SIDEBAR_LINKS } from '@marketplace/config/account-sidebar.js'
import OcTag from '@shared/components/oc-tag.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'AccountSidebar',

    components: {
        OcTag,
    },

    computed: {
        ...mapGetters('global', [
            'accountType',
            'isAssociationRetailer',
            'userCountry',
        ]),
        ...mapGetters('ocplus', ['hasOcPlus', 'canSeeOcPlus']),

        sidebarLinks() {
            const currentActiveUrl = this.$route.path

            return ACCOUNT_SIDEBAR_LINKS.filter((item) => {
                const hiddenFor = item?.props?.isHiddenFor

                if (hiddenFor?.includes('notAssociationMember')) {
                    return !this.isAssociationRetailer
                }

                if (!this.canSeeOcPlus && item.id === 'oc-plus') {
                    return false
                }

                return !hiddenFor?.includes(this.accountType)
            }).map((item) => {
                if (item.id === 'plus' && !this.hasOcPlus) {
                    item.url = '/account/plus/subscribe' // change to checkout
                }

                return {
                    ...item,
                    isActive: currentActiveUrl.includes(item?.props?.isActive),
                    url: item.url,
                }
            })
        },
    },
}
